// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h1 {
  margin-bottom: 0;
  font-weight: 500;
  color: #252525;
  font-size: 40px;
  font-style: normal;
  line-height: 30px;
  letter-spacing: 0.8px;
}

.container {
  text-align: center;
}

p.lead {
  color: #565656;
  text-align: center;
  font-family: var(--font-family);
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.36px;
  padding-top: 8px;
}

.form-field {
  display: flex;
  flex-flow: column;
  width: 100%;
  margin-top: 36px;
}

.form-wrapper .signIn {
  padding-top: 57px;
}

.form-wrapper .forgot-password p.lead {
  color: #252525;
  text-align: center;
  font-family: var(--font-family);
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-block: 20px 10px;
}
.form-wrapper .forgot-password p.sub-lead.strong {
  color: #565656;
  text-align: center;
  font-family: var(--font-family);
  font-size: 15px;
  font-style: normal;
  font-weight: 300;
  line-height: 22px;
}
.form-wrapper .forgot-password p.small_info.loader.loader-center {
  padding: 0;
}

.form-wrapper {
  max-width: 380px;
  margin: 0 auto;
  padding-bottom: 50px;
  padding-top: 132px;
}
.form-wrapper .form-field .loader {
  display: flex;
  justify-content: center;
  padding: 0px;
  pointer-events: none;
}
.form-wrapper .btn-primary.log-in-btn {
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.16px;
  text-transform: capitalize;
  padding-block: 12.5px;
}

.btn-primary {
  margin-bottom: 20px;
  text-transform: uppercase;
}

.forgot-password {
  font-size: 0.9375rem;
}

.strong {
  font-weight: var(--font-weight--semibold);
}

.forgot-password .form-field {
  margin-top: 32px;
}
.forgot-password button.btn.btn-primary {
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  padding-block: 14px;
  text-transform: capitalize;
}

.small_info {
  font-size: 0.875rem;
  opacity: 0.75;
}

@media screen and (max-width: 767px) {
  .form-wrapper {
    padding-top: 90px;
    overflow: auto;
    max-width: 340px;
  }
  .form-wrapper .signIn {
    padding-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/login/login.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AACJ;;AACA;EACI,kBAAA;AAEJ;;AAEA;EACI,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AACJ;;AACA;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AAEJ;;AAAA;EACI,iBAAA;AAGJ;;AACI;EACI,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;AAER;AAAI;EACI,cAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAER;AAAI;EACI,UAAA;AAER;;AACA;EACI,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;AAEJ;AADI;EACI,aAAA;EACA,uBAAA;EACA,YAAA;EACA,oBAAA;AAGR;AADI;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,qBAAA;AAGR;;AACA;EACI,mBAAA;EACA,yBAAA;AAEJ;;AAAA;EACI,oBAAA;AAGJ;;AADA;EACI,yCAAA;AAIJ;;AADI;EACI,gBAAA;AAIR;AAFI;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0BAAA;AAIR;;AAAA;EACI,mBAAA;EACA,aAAA;AAGJ;;AAIA;EACI;IACI,iBAAA;IACA,cAAA;IACA,gBAAA;EADN;EAGE;IACI,iBAAA;EADN;AACF","sourcesContent":["h1{\n    margin-bottom: 0;\n    font-weight: 500;\n    color: #252525;\n    font-size: 40px;\n    font-style: normal;\n    line-height: 30px;\n    letter-spacing: 0.8px;\n}\n.container{\n    text-align: center;\n}\n\n\np.lead {\n    color: #565656;\n    text-align: center;\n    font-family:  var(--font-family);\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: 0.36px;\n    padding-top: 8px;\n}\n.form-field{\n    display: flex;\n    flex-flow: column;\n    width: 100%;\n    margin-top: 36px;\n}\n.form-wrapper .signIn{\n    padding-top: 57px;\n\n}\n.form-wrapper .forgot-password{\n    p.lead {\n        color: #252525;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 20px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        padding-block: 20px 10px;\n    }\n    p.sub-lead.strong {\n        color: #565656;\n        text-align: center;\n        font-family:  var(--font-family);\n        font-size: 15px;\n        font-style: normal;\n        font-weight: 300;\n        line-height: 22px;\n    }\n    p.small_info.loader.loader-center{\n        padding: 0;\n    }\n}\n.form-wrapper{\n    max-width: 380px;\n    margin: 0 auto;\n    padding-bottom: 50px;\n    padding-top: 132px;\n    .form-field .loader{\n        display: flex;\n        justify-content: center;\n        padding: 0px;\n        pointer-events: none;\n    }\n    .btn-primary.log-in-btn {\n        color: #FFF;\n        text-align: center;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 600;\n        line-height: 20px;\n        letter-spacing: 0.16px;\n        text-transform: capitalize;\n        padding-block: 12.5px;\n    }\n}\n\n.btn-primary{\n    margin-bottom: 20px;\n    text-transform: uppercase;\n}\n.forgot-password{\n    font-size: 0.9375rem;\n}\n.strong{\n    font-weight: var(--font-weight--semibold);\n}\n.forgot-password {\n    .form-field{\n        margin-top: 32px;\n    }\n    button.btn.btn-primary {\n        color: #FFF;\n        text-align: center;\n        font-size: 16px;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n        padding-block: 14px;\n        text-transform: capitalize;\n    }\n}\n\n.small_info{\n    font-size: 0.875rem;\n    opacity: .75;    \n}\n\n\n\n\n\n@media screen and (max-width:767px){\n    .form-wrapper{\n        padding-top: 90px;\n        overflow: auto;\n        max-width: 340px;\n    }\n    .form-wrapper .signIn{\n        padding-top: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
